export default {
    setLastPage(state, payload){
        state.lastPage=payload.lastPage;
    }
}